export const COOKIES = {
  DEV_JWT: "devJwt",
  SIGNED_IN: "signedIn",
};

export const LOCAL_STORAGE_PREVIEW_JWT_KEY = "CSB_PREVIEW_JWT";

export const WAIT_FOR_SIGN_IN_MESSAGE_TIMEOUT = 60000;

export const DAY = 1000 * 60 * 60 * 24;
